import flatpickr from "flatpickr";

export function initFlatPickr() {
    flatpickr('input[data-js-picker="date"]', {
        altInput: true,
        altFormat: "d.m.Y",
        dateFormat: "Y-m-d",
	    allowInput: true
    });
}
